"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateEmailLoginCheckAccountResultToJSON = exports.ActivateEmailLoginCheckAccountResultFromJSONTyped = exports.ActivateEmailLoginCheckAccountResultFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ActivateEmailLoginCheckAccountResultFromJSON(json) {
    return ActivateEmailLoginCheckAccountResultFromJSONTyped(json, false);
}
exports.ActivateEmailLoginCheckAccountResultFromJSON = ActivateEmailLoginCheckAccountResultFromJSON;
function ActivateEmailLoginCheckAccountResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'emailAddress': !(0, runtime_1.exists)(json, 'emailAddress') ? undefined : json['emailAddress'],
        'maskedEmailAddress': !(0, runtime_1.exists)(json, 'maskedEmailAddress') ? undefined : json['maskedEmailAddress'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.ActivateEmailLoginCheckAccountResultFromJSONTyped = ActivateEmailLoginCheckAccountResultFromJSONTyped;
function ActivateEmailLoginCheckAccountResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'emailAddress': value.emailAddress,
        'maskedEmailAddress': value.maskedEmailAddress,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.ActivateEmailLoginCheckAccountResultToJSON = ActivateEmailLoginCheckAccountResultToJSON;
//# sourceMappingURL=ActivateEmailLoginCheckAccountResult.js.map